import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseNabidkaWizardSearch } from '@/modules/vozidla/wizard-helpers';

const NabidkaWizard = lazy(() =>
  import('@/modules/vozidla/NabidkaWizard').then((m) => ({ default: m.NabidkaWizard })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/nabidky/wizard',
  component: () => (
    <Suspense fallback={null}>
      <NabidkaWizard />
    </Suspense>
  ),
  validateSearch: parseNabidkaWizardSearch,
});
